import {Box, Theme, Typography} from '@mui/material';
import {FormattedDateParts} from 'react-intl';
import {COMPANY_NAME} from '../common/constants';
import {AppInstallPrompt} from '../pwa/AppInstallPrompt';
import {ComponentWithoutChildren} from '../react/types';
import {useDeviceState} from '../responsive/hooks/useDeviceState';

export interface FooterProps {
  withAppInstallPrompt?: boolean;
}

export const Footer: ComponentWithoutChildren<FooterProps> = ({withAppInstallPrompt}: FooterProps) => {
  const {isWide} = useDeviceState();
  return (
    <Box
      component="footer"
      data-testid="Footer"
      role="contentinfo"
      sx={{
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        mt: 'auto',
        width: '100%',
        zIndex: (theme: Theme) => theme.zIndex.appBar,
      }}
    >
      {withAppInstallPrompt && <AppInstallPrompt sx={{alignSelf: isWide ? 'flex-end' : undefined, mb: 2, mx: 2}} />}
      <Box
        sx={{
          backgroundColor: (theme: Theme) => theme.palette.action.hover,
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          py: 1,
          width: '100%',
        }}
      >
        <FormattedDateParts value={new Date()} year="numeric">
          {([year]) => (
            <Typography color="text.secondary" variant="body2">
              {`Copyright © ${COMPANY_NAME} ${year.value}`}
            </Typography>
          )}
        </FormattedDateParts>
      </Box>
    </Box>
  );
};
